/**
 * Classe responsável por rejeitar todas as sugestões selecionadas.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 13/08/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.RejectSelected = (function () {

    RejectSelected.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

    function RejectSelected () {

        this.setValueBtn = function () {
            var value = Monet.I18n.getResourcesByKey("Greenmile.ServiceTimeUpdates.RejectSelected");
            this.valueBtn = value;
        };

        this.actionAfterClickButton = function () {

            var rowsSelected       = [],
                rowsSelectedLength = 0,
                error              = null,
                grid               = null;

            try {

                grid = App.Forms.ServiceTimeUpdates.table;

                rowsSelected = grid.getSelectedRows();
                rowsSelectedLength = rowsSelected.length;

                if (rowsSelectedLength > 0) {

                    const confirmRejectSelected = () => {
                        App.Objects.ServiceTimeUpdates.rejectSelected(rowsSelected);
                    };

                    new Greenmile.Components.AlertModal("Greenmile.ServiceTimeUpdates.confirmRejectSelected",
                        null,
                        confirmRejectSelected)
                    .show();

                } else {

                    new Greenmile.Components.AlertModal("Greenmile.actionGridButton.noItemChecked")
                        .show();
                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    "Error on actionAfter click button.", e);
                error.console();

            }

        };

        this.initialize = function (entity) {

            this.setEntity(entity);
            this.setSelector("#ServiceTimeUpdates .gridHeaderContainer .rightContainer");
            this.setScreenName("#ServiceTimeUpdates");
            this.setValueBtn();
            this.setId("btnRejectSelected");
            this.setClassName("btn-secondary");
            this.setBtnSelector('#ServiceTimeUpdates #btnRejectSelected');
            this.init();
        };

    }

    return RejectSelected;

})();
